import styles from './fileTile.module.css'
import { FileType } from './types'

type Props = {
    fileType: FileType
    fileName?: string
    previewUrl?: string
    className?: string
}

const EmptyFileImg = '/assets/img/empty-file.png'
const CsvFileImg = '/assets/img/csv-file.png'
const PdfFileImg = '/assets/img/pdf-file.png'
const ImgFileImg = '/assets/img/empty-img.png'

export const FileTile = (props: Props) => {
    const { fileType, fileName, previewUrl, className } = props

    const isImage = fileType === FileType.JPEG || fileType === FileType.JPG || fileType === FileType.PNG

    const getFileImg = () => {
        if (fileType === FileType.PDF) return PdfFileImg
        if (fileType === FileType.CSV) return CsvFileImg
        if (isImage) return ImgFileImg
        return CsvFileImg
    }

    const imgSrc = fileName ? getFileImg() : EmptyFileImg
    const alt = `${fileType.toString()} File`

    return (
        <div className={`${styles.container} ${className || ''}`}>
            <div className={styles.tile}>
                {previewUrl ? (
                    <img src={previewUrl} alt={alt} className={`${styles.img} ${styles.preview}`} />
                ) : (
                    <img src={imgSrc} alt={alt} className={styles.img} />
                )}
                <span className={styles.name}>
                    {fileName || 'No hay archivo seleccionado'}
                </span>
            </div>
        </div>
    )
}
